import styled from 'styled-components'
import { Container as SelectContainer, SelectArrow, Label, NativeSelect } from '../../../components/Form/Select'

export const Container = styled.div`
  display: flex;
  border-top: 1px solid #DADADA;
`
export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
`
export const Main = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`

export const HeaderWrapper = styled.div`
  border-radius: 16px;
  border: 1px solid #DADADA;
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const EditButton = styled.button`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: none;
  background: #fff;
  color: #028BB7;
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`
export const TutorDetailsButton = styled.button`
   display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #028BB7;
  background: #fff;
  color: #028BB7;
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const AppointmentActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
`

export const SelectGroup = styled.div`
  display: inherit;
  gap: 16px;
  width: 388px;

  ${SelectContainer}{
    margin-bottom: 0px;
    flex: 0 0 194px;
  }

  ${SelectArrow}{
    right: 12px;
    transform: translateY(-50%);
    top: 50%;
    svg {
      fill: #777;
      width: 16px;
      height: 16px;
    }
  }

  ${Label}{
    display: none;
  }

  ${NativeSelect}{
    height: 40px;
    padding-left: 12px;
    font-family: 'Open Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const NewAppointmentButton = styled.button`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: none;
  background: #028BB7;
  color: #fff;
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  `

export const AppointmentsWrapper = styled.div`
  border-radius: 16px;
  border: 1px solid #DADADA;
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const AppointmentNavBar = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  border-bottom: 1px solid #DADADA;
`

export const AppointmentNavBarTitle = styled.a`
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  border-bottom: ${({ active }) => active ? '2px solid #028BB7' : 'none'};
  background: #FFF;
  color: ${({ active }) => active ? '#028BB7' : '#DADADA'};
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
  cursor: ${({ active }) => active ? 'pointer' : 'not-allowed;'};
  :hover {
    text-decoration: none;
    color: ${({ active }) => active ? '#028BB7' : '#DADADA'};
  }
`

export const Body = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`
export const IconWrapper = styled.div`
  display: flex;
  width: 96px;
  height: 96px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  background: #FFF2EE;
`
export const TitlePets = styled.div`
  color: #222;
  text-align: center;
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`
export const SubtitlePets = styled.div`
  color: #555;
  text-align: center;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`
export const BoxButton = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`
export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const CloseModalButton = styled.button`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: none;
  background: #028BB7;
  color: #fff;
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 24px;
  `
